import { IonNav } from '@ionic/react';
import {
  ReactElement,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { runInBackground, sleep } from '../../util/async';

const ModalNavigationContext = createContext<HTMLIonNavElement | null>(null);

const ModalNavigation = ({ children }: { children: ReactElement }) => {
  const ref = useRef<HTMLIonNavElement | null>(null);

  const [contextValue, setContextValue] = useState<HTMLIonNavElement | null>(
    null
  );

  useEffect(() => {
    runInBackground(async () => {
      // small workaround to make sure we only set the context value after
      // the ref is defined
      while (ref.current === null) {
        await sleep(10);
      }
      setContextValue(ref.current);
    });
  }, []);

  return (
    <ModalNavigationContext.Provider value={contextValue}>
      <IonNav ref={ref} root={() => children} />
    </ModalNavigationContext.Provider>
  );
};

const useModalNavigationContext = () => {
  return useContext(ModalNavigationContext) as HTMLIonNavElement;
};

export { ModalNavigation, useModalNavigationContext };
